export default __webpack_public_path__ + "static/media/dot_icon_text.6ec71998.svg";